var _path, _path2, _path3, _path4, _path5, _rect, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusSeat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1617 21.3994V33.0049C38.1617 34.1095 37.2663 35.0049 36.1617 35.0049H7.10547C6.0009 35.0049 5.10547 34.1095 5.10547 33.0049V21.3994M31.4094 21.3994V29.3611H12.0594V21.3994",
    stroke: "#0C2487",
    strokeWidth: 1.34375
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1625 21.4494C38.1625 19.5848 36.6509 18.0732 34.7863 18.0732C32.9217 18.0732 31.4102 19.5848 31.4102 21.4494",
    stroke: "#0C2487",
    strokeWidth: 1.34375
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0594 21.4509C12.0594 19.5855 10.5027 18.0732 8.58242 18.0732C6.66215 18.0732 5.10547 19.5855 5.10547 21.4509",
    stroke: "#0C2487",
    strokeWidth: 1.34375
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0586 35.0039L12.0586 39.0352H31.4086V35.0039",
    stroke: "#0C2487",
    strokeWidth: 1.34375
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60156 18.0732V13.0342C8.60156 9.69458 11.3088 6.9873 14.6484 6.9873H14.7828M35.2078 18.0732V13.0342C35.2078 9.69458 32.5005 6.9873 29.1609 6.9873H28.7578",
    stroke: "#0C2487",
    strokeWidth: 1.34375
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.1094,
    y: 3.89648,
    width: 15.3188,
    height: 5.64375,
    rx: 0.739063,
    stroke: "#0C2487",
    strokeWidth: 1.34375
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.898 13.6387L22.7039 16.1189H25.3118L23.202 17.6518L24.0079 20.132L21.898 18.5992L19.7882 20.132L20.5941 17.6518L18.4843 16.1189H21.0922L21.898 13.6387Z",
    stroke: "#0C2487",
    strokeWidth: 0.80625
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusSeat);
export default __webpack_public_path__ + "static/media/busSeat.7b28e83e72c3e92a23a50e3960e48513.svg";
export { ForwardRef as ReactComponent };